module.exports = __webpack_public_path__ + "img/744.7c4906bb.jpg";